import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {FORMAT, LOCALE} from '../../../providers/MomentProvider';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.scss';


const DatePickerControl = ({className, name, onChange, selected}) => {
    function onDateChange(date) {
        onChange(name, date);
    }
    moment.locale(LOCALE);
    return (
        <DatePicker
            dateFormat={FORMAT}
            className={className}
            name={name}
            selected={selected}
            onChange={onDateChange} />
    );
};

DatePickerControl.propTypes = {
    //Class which will be applied to component.
    className: PropTypes.string,
    //Component name.
    name:PropTypes.string,
    //Function triggered while input value has changed.
    onChange: PropTypes.func,
    //Input value.
    selected: PropTypes.instanceOf(moment),
};

export default DatePickerControl;


// WEBPACK FOOTER //
// ./src/components/base/DatePicker/DatePicker.js